import ObservablePropertyDescriptorObject from '../../utils/ObservablePropertyDescriptorObject';
import PropertyDescriptor from '../../utils/PropertyDescriptor';
import ModelActionPropertyBase from "./ModelActionPropertyBase";

export default class Model extends ModelActionPropertyBase {

    script = new PropertyDescriptor(``, '使用 Javascript 编写动作逻辑', "高级", "js", "#anticon-Documentation", {
        description: '在动作触发时，执行此处的脚本',
        formItemLayout: {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        }
    });

    constructor(opts = {}) {
        super();

        for (var p in opts) {
            this[p].value = opts[p];
        }

        this.defineAllProperties();
    }

    run(data, opts) {
        return opts.runScript(this.script, data, undefined, undefined, { throwException: true });
    }

    toString() {
        return this.script;
    }
}
